module.exports = __webpack_public_path__ + "img/OBCINA RADECE.19e4e71d.png";